import { render } from "./IntegrityFrameworkDownload.vue?vue&type=template&id=7891c6fe&scoped=true"
import script from "./IntegrityFrameworkDownload.vue?vue&type=script&lang=js"
export * from "./IntegrityFrameworkDownload.vue?vue&type=script&lang=js"

import "./IntegrityFrameworkDownload.vue?vue&type=style&index=0&id=7891c6fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7891c6fe"]])

export default __exports__